export default "__VITE_ASSET__wVO6pTc4__"